import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { quickReports } from '../../data/demandes';
import { AtnaConversationDialog } from './AtnaConversationDialog';
import { PromptBox } from './PromptBox';
const PANEL_LAYOUT_ID = 'atna-conversation-panel';
export function RequestComposer() {
  const [draft, setDraft] = useState('');
  const [openedWith, setOpenedWith] = useState<string | null>(null);
  const open = (value: string) => {
    const text = value.trim();
    if (!text) return;
    setOpenedWith(text);
    setDraft('');
  };
  const isOpen = openedWith !== null;
  return <section aria-labelledby="report-title" data-id="element-846" data-mp="23owd5cs6t56v">
      <h2 id="report-title" className="text-2xl font-extrabold tracking-tight text-ville-navy sm:text-3xl" data-id="element-847" data-mp="23q7c8zaotorn">
        Report a problem
      </h2>
      <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-848" data-mp="s8og1qviym2l">
        Just describe what you see. ATNA helps send the request to the right department.
      </p>

      <div className="mt-6" data-id="element-849" data-mp="x5obz8ynu8fz">
        {isOpen ?
      // Placeholder keeps the page from jumping while the pill morphs into the dialog.
      <div className="h-[66px]" aria-hidden="true" data-id="element-850" data-mp="1fbe4ma1vs1p0" /> : <motion.div layoutId={PANEL_LAYOUT_ID} style={{
        borderRadius: 999
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-851" data-mp="1t9votxskuw26">
            <PromptBox value={draft} onChange={setDraft} onSubmit={() => open(draft)} onAddPhoto={() => open(draft)} variant="hero" placeholder="What would you like to report?" data-id="element-852" data-mp="1oa9blocr1ftd" />
          </motion.div>}
      </div>

      <ul className="-mx-5 mt-4 flex snap-x gap-2.5 overflow-x-auto px-5 pb-1 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-853" data-mp="2bztvc9gq8h3p">
        {quickReports.map(quick => <li key={quick} className="shrink-0 snap-start" data-id="element-854" data-mp="2lzuik6hpvhd6">
            <button type="button" onClick={() => open(quick)} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-855" data-mp="2gzq1ae8ziilw">
              {quick}
            </button>
          </li>)}
      </ul>

      <AnimatePresence data-id="element-856" data-mp="1sfjbz6i30llc">
        {openedWith !== null && <AtnaConversationDialog key="atna-dialog" initialText={openedWith} layoutId={PANEL_LAYOUT_ID} onClose={() => setOpenedWith(null)} data-id="element-857" data-mp="1xc9tzzdg5r9e" />}
      </AnimatePresence>
    </section>;
}